const RECAPTCHA_RELOAD_TIMEOUT = 3000;

export function redirect(url: string): void {
  globalThis.location.href = url;
}

export function reloadAfterRecaptchaFailure(
  isRecaptchaFailed: boolean,
): (() => void) | undefined {
  if (isRecaptchaFailed) {
    const timer = setTimeout(() => {
      window.location.reload();
    }, RECAPTCHA_RELOAD_TIMEOUT);
    return () => clearTimeout(timer);
  }
  return undefined;
}
